import LeadListTableView from 'routes/LeadList/LeadListView/LeadListTableView/LeadListTableView';

export default LeadListTableView;
